import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleCalendarService } from '../../../../../../../../../../../shared/services/transactional/google-calendar/google-calendar.service';
import { SharedUserService } from '../../../../../../../../../../../shared/services/shared/user/shared-user.service';
import { SharedOrganizationService } from '../../../../../../../../../../../shared/services/shared/organization/shared-organization.service';
import { stat } from 'fs';
import { ToastService } from '../../../../../../../../../../../shared/services/shared/toast/toast.service';
import { finalize, Subscription } from 'rxjs';
import { SpinnerService } from '../../../../../../../../../../../shared/services/shared/spinner/spinner.service';

@Component({
  selector: 'app-google-callback',
  imports: [],
  templateUrl: './google-callback.component.html',
  styleUrl: './google-callback.component.scss',
})
export class GoogleCallbackComponent {
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _googleCalendarService: GoogleCalendarService,
    private _sharedUSerService: SharedUserService,
    private _sharedOrganizationService: SharedOrganizationService,
    private _toastService: ToastService,
    private _spinnerService: SpinnerService,
    private _cdr: ChangeDetectorRef,
  ) {}

  public subscribeUserService(): void {
    let sub = this._sharedUSerService.loggedIn$.subscribe((response) => {
      let user = response!.user;
      const code = this._route.snapshot.queryParamMap.get('code');
      const state = this._route.snapshot.queryParamMap.get('state');
      this._spinnerService.show('Connecting to Google Calendar...');
      this._cdr.detectChanges();
      let sub1 = this._googleCalendarService
        .exchangeCode(code!, state!, user.id)
        .pipe(
          finalize(() => {
            this._spinnerService.hide();
            this._cdr.detectChanges();
          }),
        )
        .subscribe({
          next: (response) => {
            if (response.isSuccess && response.data) {
              this._toastService.showSuccess(
                'Calendars assigned successfully. Google Calendar sync is now enabled.',
              );
              this._spinnerService.hide();
              this._cdr.detectChanges();
              this._router.navigate([
                `/app/${state}/business-settings/sync-calendars/${response.data.id}`,
              ]);
            }
          },
        });

      this.subs.push(sub1);
    });

    this.subs.push(sub);
  }

  public subs: Subscription[] = [];
  ngOnInit() {
    this.subscribeUserService();
  }

  ngOnDestroy(): void {
    this.subs?.forEach((s) => {
      s?.unsubscribe();
    });
  }
}
